var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_b_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M301.8,257.3c-4.7,1.4-9.9,5.4-12.5,9.8c-0.8,1.5-0.7,2.6,0.1,2.5l0.1-0.1c3.9,6,8.6,9.9,18.4,9.9 c-0.2,0-0.3,0-0.5-0.1c1.5,0.2,3,0.3,4.5,0.4c7,0.4,13.6-0.5,20.6-2c0.9-0.2,2.8-0.7,3.5-1.2c0.2-0.2,0.3-0.4,0.3-0.6l0,0 C338,262.3,318.5,252.3,301.8,257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M423.3,267.2c-2.5-4.5-7.8-8.4-12.5-9.8c-16.7-5-36.2,5-34.6,18.6c1-4.3,1-4.3,0,0 c0.1,0.2,0.2,0.4,0.3,0.6c0.7,0.6,2.6,1.1,3.5,1.2c6.9,1.5,13.6,2.5,20.6,2c1.6-0.1,3.1-0.2,4.5-0.4c-0.2,0-0.3,0.1-0.5,0.1 c9.8,0,14.5-3.9,18.4-9.9l0.1,0.1C424,269.8,424.2,268.7,423.3,267.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M290.8,268.2c6.5-6.2,18.4-9.3,28.4-7.6c7.9,1.5,15.5,7.6,17.3,15.2c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.7,0.6-2.6,1.1-3.5,1.2c-6.9,1.5-13.6,2.5-20.6,2c-1.6-0.1-3.1-0.2-4.5-0.4C301.7,278.5,294.8,275.4,290.8,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M336.5,275.8c0-0.1,0-0.2,0-0.4C336.5,275.6,336.5,275.7,336.5,275.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9C9F7B",
    d: "M319.2,260.7c0.3,0,0.5,0.1,0.8,0.2c2.4,1.8,4,4.7,4,7.9c0,5.5-4.5,9.9-10,9.9s-10-4.4-10-9.9 c0-3.4,1.7-6.4,4.3-8.2C311.9,260.1,315.7,260.1,319.2,260.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#231B18",
    cx: 314.2,
    cy: 268.2,
    rx: 5.2,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D1E",
    d: "M289.4,267.2c2.5-4.5,7.8-8.4,12.5-9.8c16.7-5,36.2,5,34.6,18.6c-1.7-7.6-9.4-13.8-17.3-15.3 c-10-1.7-21.8,1.3-28.4,7.6c4.1,7.4,11.3,10.4,17.2,11.2c-9.8,0-14.5-3.9-18.4-9.9l-0.1,0.1C288.6,269.8,288.5,268.7,289.4,267.2z "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 314,
    cy: 267.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M421.9,268.2c-6.5-6.2-18.4-9.3-28.4-7.6c-7.9,1.5-15.5,7.6-17.3,15.2c0.1,0.2,0.2,0.4,0.3,0.6 c0.7,0.6,2.6,1.1,3.5,1.2c6.9,1.5,13.6,2.5,20.6,2c1.6-0.1,3.1-0.2,4.5-0.4C411,278.5,417.9,275.4,421.9,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M376.2,275.8c0-0.1,0-0.2,0-0.4C376.2,275.6,376.2,275.7,376.2,275.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9C9F7B",
    d: "M393.5,260.7c-0.3,0-0.5,0.1-0.8,0.2c-2.4,1.8-4,4.7-4,7.9c0,5.5,4.5,9.9,10,9.9s10-4.4,10-9.9 c0-3.4-1.7-6.4-4.3-8.2C400.7,260.1,397,260.1,393.5,260.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#231B18",
    cx: 398.5,
    cy: 268.2,
    rx: 5.2,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D1E",
    d: "M423.3,267.2c-2.5-4.5-7.8-8.4-12.5-9.8c-16.7-5-36.2,5-34.6,18.6c1.7-7.6,9.4-13.8,17.3-15.3 c10-1.7,21.8,1.3,28.4,7.6c-4.1,7.4-11.3,10.4-17.2,11.2c9.8,0,14.5-3.9,18.4-9.9l0.1,0.1C424,269.8,424.2,268.7,423.3,267.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 398.7,
    cy: 267.6,
    r: 1.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape2C);
export default __webpack_public_path__ + "static/media/eyeshape_2c.00ae1f3217ad2d2c19e20ae9646bebdc.svg";
export { ForwardRef as ReactComponent };